import React from "react";
import AppView from "../../components/Layout/AppView";

const TransactionsPage = () => {
  return <AppView>Transactions Page</AppView>;
};

export default TransactionsPage;
